import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { ButtonGroup } from '@mui/material'
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined'
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined'
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined'
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import SidebarAction from '/components/sidebar-action'

const Menu = ({ client, user }) => {

  const navigate = useNavigate()
  const page = location.pathname.split("/").pop()

  const buttons = useMemo(() => {
    let t = []
    const hasClientManagedAppleCertificate = [client, ...(client?.available_clients ?? [])]
      .some(item => item?.apple_team_id && item.apple_team_id !== '37MPX49VX9')
    t.push(<SidebarAction key="profile" label="Profile" icon={<LockOutlinedIcon />} active={page === "profile" || page === "password"} onClick={() => navigate("../profile")} />)

    if (user?.permissions.client_admin) {
      t.push(<SidebarAction key="details" label="Company Details" icon={<BusinessOutlinedIcon />} active={page === "details"} onClick={() => navigate("../details")} />)      
      t.push(<SidebarAction key="users" label="Users" icon={<GroupOutlinedIcon />} active={page === "users"} onClick={() => navigate("../users")} />)
      t.push(<SidebarAction key="api-keys" label="API Keys" icon={<KeyOutlinedIcon />} active={page === "api-keys"} onClick={() => navigate("../api-keys")} />)
      if (hasClientManagedAppleCertificate) {
        t.push(<SidebarAction key="certificates" label="Signing Certificates" icon={<VerifiedUserOutlinedIcon />} active={page === "certificates"} onClick={() => navigate("../certificates")} />)
      }
      t.push(<SidebarAction key="delete" label={client?.billing_mode === "postpay" ? "Request Termination" : "Delete Account"} icon={<DeleteOutlineOutlinedIcon />} onClick={() => navigate("../delete")} />)
    }
    return t
    
  }, [client, user, page])

  return (
    <div className='flex flex-col'>
      <div className='flex flex-row justify-end w-full'>
        <ButtonGroup variant="text" aria-label="Actions">
          {buttons}
        </ButtonGroup>
      </div>
    </div>
  )
}

export default Menu
